(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kc-topbar-player"] && !Shopify.designMode) return;
  try {
    (function () {
    var PLAYER_STORAGE_KEY = 'kc_player_state_v1';

    /*-------- SHARED YOUTUBE IFRAME API LOADER --------*/
    function loadYTAPI() {
      if (window.__kcYTPromise) return window.__kcYTPromise;
      window.__kcYTPromise = new Promise(function (resolve) {
        if (window.YT && window.YT.Player) { resolve(window.YT); return; }
        var prev = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
          if (typeof prev === 'function') { try { prev(); } catch (e) {} }
          resolve(window.YT);
        };
        if (!document.querySelector('script[src*="iframe_api"]')) {
          var s = document.createElement('script');
          s.src = 'https://www.youtube.com/iframe_api';
          document.head.appendChild(s);
        }
      });
      return window.__kcYTPromise;
    }

    function fmt(s) {
      if (!isFinite(s) || s == null) return '0:00';
      var m = Math.floor(s / 60), sec = Math.floor(s % 60);
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    document.querySelectorAll('.kc-topbar-player').forEach(function (player) {
      if (player.dataset.kcInit === '1') return;
      player.dataset.kcInit = '1';

      var root      = player.closest('.kc-topbar') || player;
      var bid       = player.dataset.blockId;
      var ytVideoId = (player.dataset.kcYtId || '').trim();
      var mountId   = 'kc-yt-' + bid;

      var playBtn  = player.querySelector('[data-kc-action="play"]');
      var prevBtn  = player.querySelector('[data-kc-action="prev"]');
      var nextBtn  = player.querySelector('[data-kc-action="next"]');
      var muteBtn  = player.querySelector('[data-kc-action="mute"]');
      var progBar  = player.querySelector('[data-kc-progress]');
      var progFill = player.querySelector('[data-kc-fill]');
      var current  = player.querySelector('[data-kc-current]');
      var duration = player.querySelector('[data-kc-duration]');
      var volBar   = player.querySelector('[data-kc-volume]');
      var volFill  = player.querySelector('[data-kc-volume-fill]');

      if (!ytVideoId) return;

      var ytPlayer = null, ytReady = false, isPlaying = false, isMuted = false;
      var lastVolume = 70, progressInterval = null, savedState = null;

      try {
        var stored = localStorage.getItem(PLAYER_STORAGE_KEY);
        if (stored) {
          var parsed = JSON.parse(stored);
          if (parsed && parsed.savedAt && (Date.now() - parsed.savedAt) < 5 * 60 * 1000) {
            savedState = parsed;
            if (typeof parsed.volume === 'number') lastVolume = parsed.volume;
            if (parsed.muted) isMuted = true;
          }
        }
      } catch (e) { /* ignore */ }

      if (volFill) volFill.style.width = lastVolume + '%';

      function persist() {
        if (!ytReady || !ytPlayer) return;
        try {
          localStorage.setItem(PLAYER_STORAGE_KEY, JSON.stringify({
            videoId: ytVideoId,
            currentTime: ytPlayer.getCurrentTime() || 0,
            isPlaying: isPlaying,
            volume: lastVolume,
            muted: isMuted,
            savedAt: Date.now()
          }));
        } catch (e) { /* ignore */ }
      }

      window.addEventListener('pagehide', persist);
      window.addEventListener('beforeunload', persist);
      setInterval(function () { if (isPlaying) persist(); }, 3000);

      function startProgressLoop() {
        stopProgressLoop();
        progressInterval = setInterval(function () {
          if (!ytReady || !ytPlayer) return;
          var cur = ytPlayer.getCurrentTime();
          var dur = ytPlayer.getDuration();
          if (dur > 0) {
            if (progFill) progFill.style.width = ((cur / dur) * 100) + '%';
            if (current)  current.textContent  = fmt(cur);
            if (duration) duration.textContent = fmt(dur);
          }
        }, 250);
      }
      function stopProgressLoop() {
        if (progressInterval) clearInterval(progressInterval);
        progressInterval = null;
      }

      loadYTAPI().then(function (YT) {
        ytPlayer = new YT.Player(mountId, {
          height: '150', width: '200',
          videoId: ytVideoId,
          host: 'https://www.youtube-nocookie.com',
          playerVars: {
            playsinline: 1, controls: 0, disablekb: 1,
            modestbranding: 1, rel: 0, enablejsapi: 1,
            origin: window.location.origin || 'https://localhost'
          },
          events: {
            onReady: function () {
              ytReady = true;
              ytPlayer.setVolume(lastVolume);
              if (isMuted) ytPlayer.mute();

              if (savedState && savedState.videoId === ytVideoId) {
                if (savedState.isPlaying) {
                  var elapsed = (Date.now() - savedState.savedAt) / 1000;
                  ytPlayer.seekTo(savedState.currentTime + elapsed, true);
                  ytPlayer.playVideo();
                } else {
                  ytPlayer.seekTo(savedState.currentTime, false);
                  ytPlayer.pauseVideo();
                  setTimeout(function () {
                    if (ytPlayer && ytPlayer.getPlayerState && ytPlayer.getPlayerState() !== YT.PlayerState.PAUSED) {
                      ytPlayer.pauseVideo();
                    }
                  }, 100);
                  isPlaying = false;
                  root.classList.remove('is-playing');
                  var ratio = savedState.currentTime / (ytPlayer.getDuration() || 1);
                  if (progFill) progFill.style.width = (Math.min(1, Math.max(0, ratio)) * 100) + '%';
                  if (current)  current.textContent  = fmt(savedState.currentTime);
                }
              }

              var tryDuration = setInterval(function () {
                var d = ytPlayer.getDuration();
                if (d > 0) {
                  if (duration) duration.textContent = fmt(d);
                  if (savedState && !savedState.isPlaying && savedState.videoId === ytVideoId) {
                    var r = savedState.currentTime / d;
                    if (progFill) progFill.style.width = (Math.min(1, Math.max(0, r)) * 100) + '%';
                  }
                  clearInterval(tryDuration);
                }
              }, 200);
            },
            onStateChange: function (e) {
              if (e.data === YT.PlayerState.PLAYING) {
                isPlaying = true;
                root.classList.add('is-playing');
                root.classList.remove('is-loading');
                startProgressLoop();
              } else if (e.data === YT.PlayerState.PAUSED) {
                isPlaying = false;
                root.classList.remove('is-playing');
                stopProgressLoop();
                persist();
              } else if (e.data === YT.PlayerState.ENDED) {
                isPlaying = false;
                root.classList.remove('is-playing');
                stopProgressLoop();
                ytPlayer.seekTo(0);
                if (progFill) progFill.style.width = '0%';
                if (current)  current.textContent  = '0:00';
                try { localStorage.removeItem(PLAYER_STORAGE_KEY); } catch (err) {}
              } else if (e.data === YT.PlayerState.BUFFERING) {
                root.classList.add('is-loading');
              }
            },
            onError: function () { root.classList.remove('is-loading'); }
          }
        });
      });

      if (playBtn) playBtn.addEventListener('click', function () {
        if (!ytReady) { root.classList.add('is-loading'); return; }
        if (isPlaying) ytPlayer.pauseVideo(); else ytPlayer.playVideo();
      });
      if (prevBtn) prevBtn.addEventListener('click', function () {
        if (!ytReady) return;
        ytPlayer.seekTo(Math.max(0, ytPlayer.getCurrentTime() - 10), true);
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (!ytReady) return;
        ytPlayer.seekTo(Math.min(ytPlayer.getDuration(), ytPlayer.getCurrentTime() + 10), true);
      });
      if (progBar) progBar.addEventListener('click', function (e) {
        if (!ytReady) return;
        var rect = progBar.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / rect.width;
        var dur = ytPlayer.getDuration();
        if (dur > 0) {
          ytPlayer.seekTo(dur * ratio, true);
          if (progFill) progFill.style.width = (ratio * 100) + '%';
        }
      });
      if (volBar) volBar.addEventListener('click', function (e) {
        if (!ytReady) return;
        var rect = volBar.getBoundingClientRect();
        var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        var vol = Math.round(ratio * 100);
        ytPlayer.setVolume(vol);
        if (volFill) volFill.style.width = (ratio * 100) + '%';
        lastVolume = vol;
        if (vol === 0) { isMuted = true; }
        else if (isMuted) { isMuted = false; ytPlayer.unMute(); }
      });
      if (muteBtn) muteBtn.addEventListener('click', function () {
        if (!ytReady) return;
        if (isMuted) {
          ytPlayer.unMute();
          ytPlayer.setVolume(lastVolume);
          if (volFill) volFill.style.width = lastVolume + '%';
          isMuted = false;
        } else {
          lastVolume = ytPlayer.getVolume() || 70;
          ytPlayer.mute();
          if (volFill) volFill.style.width = '0%';
          isMuted = true;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
